import { Store } from "vuex";
import ProjectManager from "@/entities/project-manager";

export default interface ProjectManagerOutputPort {
  info(managers: ProjectManager[]): void;
  error(message: string): void;
}

export class VuexProjectManagerPresenter {
  public constructor(private $store: Store<any>) {}

  public info(managers: ProjectManager[]) {
    this.$store.commit("member/load-managers", managers);
  }

  public error(message: string) {
    alert(message);
  }
}
